export class ErrorResponse {
    code: string;
}

export enum NotFoundConstantCode {
    Page = 'Page',
    Cycle = 'Cycle'
}